module.exports = __webpack_public_path__ + "img/selected0-min.6fcc2cb3.png";